import styles from './styles.module.scss';
import Menu from 'models/Menu';
import { updateCookieCurrentProduct } from 'utils/productCookies';

type MenuProps = {
  productNoun : string,
  breadcrumb : string,
  menu: Menu
}

function SubMenu({ productNoun, menu } : MenuProps) : JSX.Element {

  return (
    <a className={styles['biobar-sub-menu']} href={menu.url}  onClick={() : void => {
      updateCookieCurrentProduct(productNoun);
    }}>
      {menu.name}
    </a>
  );
}

export default SubMenu;